import PiadaOneApi from './PiadaOneApi';
import type CateringOrder from '../types/CateringOrder';
import CateringOrderSuggestion from '../classes/CateringOrderSuggestion';
import type ChoiceCustomFieldInterface from '@/types/ChoiceCustomField';
import type OrderProduct from '../types/OrderProduct';
import { plainToClass } from 'class-transformer';

import { useUserStore } from '../stores/user'

export default {
  getCateringOrder(id: number): Promise<any> {
    return new Promise((resolve, reject) => {
      PiadaOneApi.get(
        '/catering_orders/'+id,
        {
          headers: {
            'X-User-Verify': 'header',
            'X-Forward-Session': 'true'
          }
        },
      ).then((response) => {
        if (response.status === 200 && response.data) {
          const jsonObj = response.data as CateringOrder;

          resolve(jsonObj);
        } else {
          reject(new Error('ERROR'));
        }
      }).catch((error: Error) => {
          reject(error);
      });
    });
  },
  getCateringOrderSuggestion(id: number): Promise<any> {
    return new Promise((resolve, reject) => {
      PiadaOneApi.get(
        '/catering_orders/'+id+'/suggested_orders',
        {
          headers: {
            'X-User-Verify': 'header',
            'X-Forward-Session': 'true'
          }
        },
      ).then((response) => {
        let orderSuggestion = {} as CateringOrderSuggestion;
         if (response.status === 200 && response.data) {
          const jsonObjs = response.data as CateringOrderSuggestion[];
          let orderSuggestions = [] as CateringOrderSuggestion[];
          orderSuggestions = jsonObjs.map(
            (sug) => plainToClass(CateringOrderSuggestion, (sug as object), { excludeExtraneousValues: true }),
          );
          resolve(orderSuggestions);
        } else {
          reject(new Error('Error'));
        }
      }).catch((error: Error) => {
          reject(error);
      });
    });
  },
  updateCateringOrder(id: number, order: CateringOrder): Promise<any> {
    return new Promise((resolve, reject) => {
      let body = JSON.stringify(order);
      PiadaOneApi.put(
        '/catering_orders/'+id,
        body,
        {
          headers: {
            'X-User-Verify': 'header',
            'X-Forward-Session': 'true'
          }
        },
      ).then((response) => {
        if (response.status === 200 && response.data) {
          const jsonObj = response.data as CateringOrder;

          resolve(jsonObj);
        } else {
          reject(new Error('ERROR'));
        }
      }).catch((error: Error) => {
          reject(error);
      });
    });
  },
  createCateringOrder(order: CateringOrder): Promise<any> {
    return new Promise((resolve, reject) => {
      let body = JSON.stringify(order);
      PiadaOneApi.post(
        '/catering_orders',
        body,
        {
          headers: {
            'X-User-Verify': 'header',
            'X-Forward-Session': 'true'
          }
        },
      ).then((response) => {
        if (response.status === 200 && response.data) {
          const jsonObj = response.data as CateringOrder;
          resolve(jsonObj);
        } else {
          reject(new Error('ERROR'));
        }
      }).catch((error: Error) => {
          reject(error);
      });
    });
  },
  trackSuggestionConversion(id: number, suggestion_id: string, product: OrderProduct): Promise<any> {
    return new Promise((resolve, reject) => {

      const body = JSON.stringify({
        "suggestion_id": suggestion_id,
        "productid": product.id,
        "quantity": product.quantity,
        "specialinstructions": product.specialInstructions,
        "options": product.options
      })

      PiadaOneApi.post(
        '/catering_orders/'+id+'/suggestion_conversion',
        body,
        {
          headers: {
            'X-User-Verify': 'header',
            'X-Forward-Session': 'true'
          }
        },
      ).then((response) => {
        if (response.status === 200) {
          resolve('');
        } else {
          reject(new Error('ERROR'));
        }
      }).catch((error: Error) => {
        reject(error);
      });
    });
  },
};
